module.exports = __webpack_public_path__ + "images/menu-no-image.534a09bbb1398199a0ceb714fa6f4943.png";